import { routing } from '../../../../../../utils/routing'
import type { Post } from '../../../types'

export const getBackUrl = (scheduleStatus: Post['statuses']['schedule']) => {
  if (scheduleStatus === 'Future') {
    return {
      pathname: routing.memberships.posts.scheduled.all,
      search: location.search,
    }
  }

  return {
    pathname: routing.memberships.posts.self,
    search: location.search,
  }
}
